import React from 'react';
import classnames from 'classnames';
import {Accordion} from '@social-native/snclient-ui';
import * as guidelineHelper from './guidelines_utils';
import CampaignContentGuidelinesSection from './campaign_content_guidelines_section';

const CampaignContentGuidelines = ({gqlData}) => {
    const [parsedCampaignGuidelines, setParsedCampaignGuidelines] = React.useState([]);
    const [parsedGeneralGuidelines, setParsedGeneralGuidelines] = React.useState([]);
    const [generalGuidelinesExpanded, setGeneralGuidelinesExpanded] = React.useState(false);

    const toggleGeneralGuidelines = () => {
        setGeneralGuidelinesExpanded(!generalGuidelinesExpanded);
    }

    React.useEffect(() => {
        if (gqlData && gqlData.guidelines) {
            setParsedCampaignGuidelines(
                guidelineHelper.parseCampaignGuidelineNodes(gqlData.guidelines)
            );
        }
    }, [gqlData?.guidelines]);

    React.useEffect(() => {
        if (gqlData && gqlData.generalGuidelines) {
            setParsedGeneralGuidelines(
                guidelineHelper.parseCampaignGuidelineNodes(gqlData.generalGuidelines)
            );
        }
    }, [gqlData?.generalGuidelines]);

    if (!parsedCampaignGuidelines.length && !parsedGeneralGuidelines.length) {
        return null;
    }

    const campaignContentGuidelines = guidelineHelper.getContentGuidelines(
        parsedCampaignGuidelines
    );
    const campaignCaptionGuidelines = guidelineHelper.getCaptionGuidelines(
        parsedCampaignGuidelines
    );
    const generalContentGuidelines = guidelineHelper.getContentGuidelines(
        parsedGeneralGuidelines
    );
    const generalCaptionGuidelines = guidelineHelper.getCaptionGuidelines(
        parsedGeneralGuidelines
    );

    return (
        <div className="detail-section campaign-guidelines">
            <div className="detail-section-title">
                <h5>Campaign Rules</h5>
            </div>

            {parsedCampaignGuidelines.length > 0 && (
                <div className="detail-section-grid">
                    <div className="detail-section-grid-item">
                        <p className="content-section-title -no-margin">Content Guidelines</p>

                        <div className="item-value">
                            <CampaignContentGuidelinesSection
                                guidelines={campaignContentGuidelines}
                            />
                        </div>
                    </div>

                    <div className="detail-section-grid-item">
                        <p className="content-section-title -no-margin">Caption Guidelines</p>

                        <div className="item-value">
                            <CampaignContentGuidelinesSection
                                guidelines={campaignCaptionGuidelines}
                            />
                        </div>
                    </div>
                </div>
            )}

            {parsedGeneralGuidelines.length > 0 && (
                <Accordion
                    className={classnames(
                        'general-guidelines',
                        {
                            'general-guidelines-margin-top': parsedCampaignGuidelines.length > 0,
                            'general-guidelines-expanded': generalGuidelinesExpanded,
                            'general-guidelines-collapsed': !generalGuidelinesExpanded
                        }
                    )}
                >
                    <Accordion.Section
                        title="Social Native Guidelines"
                        expanded={generalGuidelinesExpanded}
                        onChange={toggleGeneralGuidelines}
                    >
                        <div className="detail-section-grid">
                            <div className="detail-section-grid-item">
                                <p className="content-section-title -no-margin">
                                    Content Guidelines
                                </p>

                                <div className="item-value">
                                    <CampaignContentGuidelinesSection
                                        guidelines={generalContentGuidelines}
                                    />
                                </div>
                            </div>

                            <div className="detail-section-grid-item">
                                <p className="content-section-title -no-margin">
                                    Caption Guidelines
                                </p>

                                <div className="item-value">
                                    <CampaignContentGuidelinesSection
                                        guidelines={generalCaptionGuidelines}
                                    />
                                </div>
                            </div>
                        </div>
                    </Accordion.Section>
                </Accordion>
            )}
        </div>
    );
};

export default CampaignContentGuidelines;



// WEBPACK FOOTER //
// ./components/campaign_content_guidelines/campaign_content_guidelines.js